/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssessmentPresetMergeDto { 
    id?: string;
    text?: string;
    basis?: string;
    referenceWork?: string;
    actionId?: string;
    checkpointId?: string;
    checkInterval?: AssessmentPresetMergeDto.CheckIntervalEnum;
    buildingEquipmentRelated?: boolean;
    standardAssessment?: boolean;
    standardEquipmentId?: string;
    deprecated?: boolean;
}
export namespace AssessmentPresetMergeDto {
    export type CheckIntervalEnum = 'YEAR' | 'HALF_YEAR' | 'ONE_MONTH' | 'NONE' | 'TEN_DAYS';
    export const CheckIntervalEnum = {
        Year: 'YEAR' as CheckIntervalEnum,
        HalfYear: 'HALF_YEAR' as CheckIntervalEnum,
        OneMonth: 'ONE_MONTH' as CheckIntervalEnum,
        None: 'NONE' as CheckIntervalEnum,
        TenDays: 'TEN_DAYS' as CheckIntervalEnum
    };
}


